import React from 'react';
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './Header';
import Home from './Home';
import Support from './Support';
import QuickStartGuide from './QuickStartGuide';
import QuickStartGuidePlates from './QuickStartGuidePlates';
import QuickStartGuideFrame from './QuickStartGuideFrame';
import DealerSelect from './DealerSelect';
import ChoosePhototype from './ChoosePhototype';
import FrameSelection from './FrameSelection';
import UploadPlates from './UploadPlates';
import UploadFrame from './UploadFrame';
import LicensePlatePhotography from './LicencePlatePhotography';
import LicencePlateConfirm from './LicencePlateConfirm';
import Photography from './Photography';
import PhotoGallery from './PhotoGallery';
import PhotoConfirm from './PhotoConfirm';
import FAQ from './FAQ';
import DealerID from './DealerID';
import ThankYou from './thankyou';
import { getGlobalDealerName } from './globalState';
import { getSessionToken } from './api';

/*
  Route guard: the photo flow only makes sense once a brand is chosen
  (and, past the ID step, once the dealer has a validated session).
  Landing on these pages without that state - e.g. after a deep link or
  a relaunch where sessionStorage was cleared - redirects to the start
  of the flow instead of failing later at submit time.
*/
function RequireDealer({ needSession = false, children }) {
  if (!getGlobalDealerName() || (needSession && !getSessionToken())) {
    return <Navigate to="/dealer-select" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dealer-select" element={<DealerSelect />} />
        <Route path="/dealer-id" element={<RequireDealer><DealerID /></RequireDealer>} />
        <Route path="/quick-start-guide" element={<RequireDealer needSession><QuickStartGuide /></RequireDealer>} />
        <Route path="/choose-phototype" element={<RequireDealer needSession><ChoosePhototype /></RequireDealer>} />
        <Route path="/frame-selection" element={<RequireDealer needSession><FrameSelection /></RequireDealer>} />
        <Route path="/upload-plates" element={<RequireDealer needSession><UploadPlates /></RequireDealer>} />
        <Route path="/upload-frame" element={<RequireDealer needSession><UploadFrame /></RequireDealer>} />
        <Route path="/quick-start-guide-plates" element={<RequireDealer needSession><QuickStartGuidePlates /></RequireDealer>} />
        <Route path="/quick-start-guide-frame" element={<RequireDealer needSession><QuickStartGuideFrame /></RequireDealer>} />
        <Route path="/license-plate-photography" element={<RequireDealer needSession><LicensePlatePhotography /></RequireDealer>} />
        <Route path="/license-plate-confirm" element={<RequireDealer needSession><LicencePlateConfirm /></RequireDealer>} />
        <Route path="/photography" element={<RequireDealer needSession><Photography /></RequireDealer>} />
        <Route path="/photo-gallery" element={<RequireDealer needSession><PhotoGallery /></RequireDealer>} />
        <Route path="/photo-confirm" element={<RequireDealer needSession><PhotoConfirm /></RequireDealer>} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/support" element={<Support />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </div>
  );
}

export default App;
